export * from './MenuPersonalizedRecommendations.generated';
